import React from 'react';
import store from "./store/store";
import GlobalStyle from "./theme/global-style";
import {AuthorizationWrapper} from "./components/authorization";
import {Provider} from "react-redux";
import axios from "axios";
import {BrowserRouter as Router} from "react-router-dom";
import ReactPixel from 'react-facebook-pixel';
import GA4React from "ga-4-react";
import * as LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import 'react-image-lightbox/style.css';
import enPublisherTranslate from './i18n/en/publisher.json';
import enCommonTranslate from './i18n/en/common.json';
import enAuthorTranslate from './i18n/en/author.json';
import plPublisherTranslate from './i18n/pl/publisher.json';
import plCommonTranslate from './i18n/pl/common.json';
import plAuthorTranslate from './i18n/pl/author.json';
import {AxiosSettings} from "./components/axios-settings";

const ga4react = new GA4React("G-YXT69M215N");
const resources = {
    en: {
        publisher: enPublisherTranslate,
        common: enCommonTranslate,
        author: enAuthorTranslate
    },
    pl: {
        common: plCommonTranslate,
        publisher: plPublisherTranslate,
        author: plAuthorTranslate
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'en',
        ns: ['common', 'publisher', 'author'],
        defaultNS: 'common',
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

function App() {
    axios.defaults.baseURL = process.env.REACT_APP_API;

    const setScript = (url: string) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        document.head.appendChild(script);
    }

    if (process.env.REACT_APP_USERBACK === 'true') {
        setScript(window.location.origin + '/plugins/userback.js');
    } else if (process.env.REACT_APP_USERBACK === 'false') {
        setScript(window.location.origin + '/plugins/chat.js');

        LogRocket.init('oxmhrp/bookscout');
        setupLogRocketReact(LogRocket);

        ReactPixel.init('255795402034473');
        ReactPixel.pageView();

        ga4react.initialize();
    }

    if (window.navigator.language === 'pl-PL') {
        i18n.changeLanguage('pl');
        axios.defaults.headers.common['Accept-Language'] = 'pl-PL';
    } else {
        i18n.changeLanguage('en');
        axios.defaults.headers.common['Accept-Language'] = 'en-US';
    }

    return (
        <>
            <Provider store={store}>
                <AxiosSettings>
                    <GlobalStyle/>
                    <Router>
                        <AuthorizationWrapper/>
                    </Router>
                </AxiosSettings>
            </Provider>
        </>
    );
}

export default App;
